import React from 'react';
import { useInterface } from '../../context/InterfaceProvider';
import SciFiIcon from './SciFiIcon';

export default function SimpleCardsHeader({ count }) {
  const { version } = useInterface();
  if (version !== 'simple') return null;
  return (
    <header className="simple-cards-heading simple-neon-panel">
      <h1><SciFiIcon kind="card" />Cards</h1>
      <p>{count.toLocaleString()} cards</p>
    </header>
  );
}
